module.exports = __webpack_public_path__ + "static/media/15e-02_ST-11-2015-1829x1372mm-oleo-sobre-madera.058e5b2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15e/15e-02_ST-11-2015-1829x1372mm-oleo-sobre-madera.jpg
// module id = 171
// module chunks = 0